import {InitPage} from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;
declare const isClientShopify: string;

export interface ShopifyProgressChannelData {
    message: string;
    progress: number;
    inProgress: boolean;
    success: boolean;
}

class ShopifyProgressUpdate {
    shopifyProgressUpdateChannel: any;

    constructor() {
        var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;
        var isClientShopifyy = (typeof isClientShopify === "undefined") ? false : isClientShopify;

        if(isClientShopifyy == "true") {
            this.shopifyProgressUpdateChannel = App.cable.subscriptions.create(
                {
                    channel: "Shopify::SyncProgressChannel",
                    tenant_code: x,
                    roomId: `shopify_sync_${x}`
                },
                {
                    connected() {
                        console.log("Connected to Shopify Progress Update Channel");
                    },
                    disconnected() {
                        console.log("Disconnected to Shopify Progress Update Channel");
                    },
                    received: (data: any) => this.updateProgress(data)
                }
            );
        }

    }

    updateProgress(data: ShopifyProgressChannelData) {
      console.log(data);

      const inSyncDialog = $("#sync-quantities-dialog").is(":visible");

      $(".currentStatusDesc_Category").text(`${data.message}`);
      $("#shopify_sync_progress").text(data.message);

      if (data.message == "Before syncing, you must download the quantity. Please complete the \"Download Quantity\” first.") {
        $(".sync-actions > .previewSyncBtn").hide();
        $(".sync-actions > .shopify-sync-btn").hide();
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatusDesc_Category").css("color", "red");
        return;
      }

      if ((data.message == "Sync has been cancelled" || data.message == "Synchronization failed") && inSyncDialog) {
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();

        this.refresh();
        return;
      }

      if (data.message == "Preview successfully generated" && inSyncDialog) {
        $(".sync-actions > .previewSyncBtn").removeAttr("disabled");
        $(".sync-actions > .shopify-sync-btn").removeAttr("disabled");
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .fail-img").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        return;
      }

      if (data.message == "Synchronization completed") {
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        $(".currentStatus .fail-img").hide();

        let _this = this;
        setTimeout(function() {
          _this.refresh();
        }, 2000);
        return;
      }

      if (data.message == "Matching 100%, no discrepancies detected") {
        $(".sync-actions > .previewSyncBtn").hide();
        $(".sync-actions > .shopify-sync-btn").hide();
        $(".currentStatus .progress-spin").hide();
        $(".currentStatus .success-img").removeClass("hide").show();
        $(".currentStatus .fail-img").hide();
        return;
      }

        $("#shopify_sync").show();
        $("#shopify_sync_btn").hide();
        $("#last_update").hide();
        $(".progress-bar").css("width", `${data.progress}%`);
        $("#shopifyProgressLabel").text(`${data.progress}%`);
        if (!data.inProgress && data.success && !inSyncDialog) {
            $("#shopify_sync_btn").show();
            $("#last_update").show();
            $(".shopify-header").hide();

            let _this = this;
            setTimeout(function() {
                _this.refresh();
            }, 2000);
        }

        if (!data.success && !inSyncDialog) {
            this.refresh();
        }
    }

    refresh(): void {
        window.location.reload();
    }
}

export function LoadPage() {
    InitPage("items", () => {
        const shopify = new ShopifyProgressUpdate();
    });
    InitPage("compare_v2", () => {
        const t = new ShopifyProgressUpdate();
    });
    InitPage("print_v2", () => {
        const t = new ShopifyProgressUpdate();
    });
}
